import React from "react"

function IconMugTea({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="mug-tea"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-mug-tea"
      {...props}
    >
      <path
        d="M20.673 20.71a.655.655 0 0 1 .106 1.3l-.106.01h-16.8a.655.655 0 0 1-.106-1.301l.106-.009h16.8zm1.084-17.437c.91 0 1.658.697 1.738 1.586l.007.16V8.46c0 .91-.697 1.658-1.586 1.739l-.16.007h-1.63l.001 5.073A3.927 3.927 0 0 1 16.41 19.2l-.209.006H8.12A3.927 3.927 0 0 1 4.2 15.488l-.006-.208V5.018c0-.91.697-1.658 1.587-1.738l.159-.007h15.818zM9.255 4.582H5.94c-.211 0-.387.15-.428.348l-.009.088V15.28a2.618 2.618 0 0 0 2.44 2.612l.178.006h8.08a2.618 2.618 0 0 0 2.612-2.44l.006-.178V4.582h-8.254v1.237l1.994 1.526a.655.655 0 0 1 .249.42l.008.1v3.954a1.2 1.2 0 0 1-1.07 1.193l-.13.007h-3.41a1.2 1.2 0 0 1-1.192-1.069l-.007-.13V7.864c0-.16.059-.314.163-.433l.087-.082 2-1.571V4.582zm.63 2.366-1.57 1.234v3.528h3.19V8.187l-1.62-1.239zm10.241 1.95h1.63c.212 0 .388-.15.428-.349l.01-.088V5.018c0-.21-.15-.387-.35-.427l-.087-.01h-1.63v4.316z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconMugTea
